var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_1601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.36542 18.7513L1.24917 19.635C1.73542 20.1213 2.53042 20.1213 3.01667 19.635L7.61042 15.0413C8.85042 15.8075 10.3117 16.25 11.8754 16.25C16.3629 16.25 20.0004 12.6125 20.0004 8.125C20.0004 3.6375 16.3629 0 11.8754 0C7.38792 0 3.75042 3.6375 3.75042 8.125C3.75042 9.68875 4.19292 11.15 4.95917 12.39L0.36542 16.9837C-0.12083 17.47 -0.12083 18.265 0.36542 18.7513ZM11.8754 13.75C10.3729 13.75 8.96042 13.165 7.89792 12.1025C6.83542 11.04 6.25042 9.6275 6.25042 8.125C6.25042 6.6225 6.83542 5.21 7.89792 4.1475C8.96042 3.085 10.3729 2.5 11.8754 2.5C13.3779 2.5 14.7904 3.085 15.8529 4.1475C16.9154 5.21 17.5004 6.6225 17.5004 8.125C17.5004 9.6275 16.9154 11.04 15.8529 12.1025C14.7904 13.165 13.3779 13.75 11.8754 13.75Z",
    fill: "#FCF3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_1601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierIcon);
export default __webpack_public_path__ + "static/media/magnifier-icon.66aa10f7044f822c5e5a66019795693f.svg";
export { ForwardRef as ReactComponent };